/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Product coverage/guarantee information
 * @export
 * @interface ProductCoverageDto
 */
export interface ProductCoverageDto {
    /**
     * Unique identifier of the coverage
     * @type {string}
     * @memberof ProductCoverageDto
     */
    id?: string;
    /**
     * Coverage code
     * @type {string}
     * @memberof ProductCoverageDto
     */
    code?: string | null;
    /**
     * Coverage label/designation
     * @type {string}
     * @memberof ProductCoverageDto
     */
    label?: string | null;
    /**
     * Short description of the coverage
     * @type {string}
     * @memberof ProductCoverageDto
     */
    summary?: string | null;
    /**
     * Whether this coverage is required
     * @type {boolean}
     * @memberof ProductCoverageDto
     */
    isRequired?: boolean;
    /**
     * Display order for sorting
     * @type {number}
     * @memberof ProductCoverageDto
     */
    displayOrder?: number;
}

/**
 * Check if a given object implements the ProductCoverageDto interface.
 */
export function instanceOfProductCoverageDto(value: object): value is ProductCoverageDto {
    return true;
}

export function ProductCoverageDtoFromJSON(json: any): ProductCoverageDto {
    return ProductCoverageDtoFromJSONTyped(json, false);
}

export function ProductCoverageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCoverageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
    };
}

export function ProductCoverageDtoToJSON(json: any): ProductCoverageDto {
    return ProductCoverageDtoToJSONTyped(json, false);
}

export function ProductCoverageDtoToJSONTyped(value?: ProductCoverageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'summary': value['summary'],
        'isRequired': value['isRequired'],
        'displayOrder': value['displayOrder'],
    };
}

